<template>
  <div class="">
    <van-popup
      v-model="iset"
      position="bottom"
      :style="{ width: '100%', height: '30%' }"
      @click-overlay="setShade"
    >
      <van-datetime-picker
        type="date"
        v-model="currentDate"
        @confirm="doConfirm"
        @cancel="doCancel"
        title="选择时间"
        :min-date="mindate"
        :max-date="maxdate"
      />
    </van-popup>
  </div>
</template>

<script>
export default {
  data() {
    return {
      currentDate: new Date(new Date().getTime() - 1000 * 60 * 60 * 24 * 4),
      itype: ""
    };
  },

  props: {
    iset: {
      type: Boolean,
      default: false
    },
    type: {
      type: Number,
      default: 2
    },
    mindate: {
      type: [String, Date],
      default: ""
    },
    maxdate: {
      type: [String, Date],
      default: ""
    },
    time1: {
      type: [String, Date],
      default: ""
    },
    time2: {
      type: [String, Date],
      default: ""
    }
  },
  methods: {
    setFrom(i) {
      this.itype = i;
    },
    doConfirm(value) {
      //this.iset = false;
      var dat = this.$setime(value, this.type);
      this.$emit("child-event", dat);
    },
    doCancel() {
      //this.iset = false;
      // var dat1 = this.$setime(this.time1,2);
      // var dat2 = this.$setime(this.time2,2);
      this.$emit("child-event");
    },
    setShade() {
      //this.iset = false;
      //var dat = this.$setime(this.maxdate,2);
      this.$emit("child-event");
    }
  }
};
</script>

<style scoped lang="scss"></style>
